// Plugins
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/blur-up/ls.blur-up';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'what-input';

// Modules
import expandable from './modules/expandable';
import accordion from './modules/accordion';

// Init
lazySizes.init();
expandable();
accordion();

// Get viewport units
const calcViewportUnits = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const vw = window.innerWidth * 0.01;
    document.documentElement.style.setProperty('--vw', `${vw}px`);

    const pageHeight = document.querySelector('main').offsetHeight;
    document.documentElement.style.setProperty('--pageH', `${pageHeight}px`);
};
calcViewportUnits();

// Get Scrollbar width
const getSBWidth = () => {
    const sb = window.innerWidth - document.body.clientWidth;
    document.documentElement.style.setProperty('--sb', `${sb}px`);
    document.body.style.overflow = '';
};
getSBWidth();

window.addEventListener('resize', () => {
    getSBWidth();
    calcViewportUnits();
});

// A11Y
const initModals = () => {
    const modals = document.querySelectorAll('[data-modal]');

    modals.forEach(modal => {
        const focusTrap = document.querySelector('[data-focus-trap]');
        const focusLoop = document.querySelector('[data-focus-loop]');

        const onTrapFocus = () => {
            focusLoop.focus();
        };

        const observer = new MutationObserver(() => {
            const isOpen =
                modal.getAttribute('aria-expanded') == 'true' ||
                modal.getAttribute('aria-hidden') == 'false';

            if (isOpen && focusTrap && focusLoop) {
                focusTrap.addEventListener('focus', onTrapFocus);
            } else if (!isOpen && focusTrap && focusLoop) {
                focusTrap.removeEventListener('focus', onTrapFocus);
            }
        });

        observer.observe(modal, { attributes: true });
    });
};
initModals();

document.body.classList.add('js');
